import React from 'react';

const TOGGLE_LOADING = "TOGGLE_LOADING";
const TOGGLE_ACCOUNT_PREFERENCES = "TOGGLE_ACCOUNT_PREFERENCES";
const OPEN_CONFIRMATION_MODAL = "OPEN_CONFIRMATION_MODAL";
const CLOSE_CONFIRMATION_MODAL = "CLOSE_CONFIRMATION_MODAL";

export const toggleLoading = (loading) => ({
  type: TOGGLE_LOADING,
  payload: { loading }
});

export const toggleAccountPreferencesModal = (openAccountPreferences) => ({
  type: TOGGLE_ACCOUNT_PREFERENCES,
  payload: { openAccountPreferences }
});

export const openConfirmationModal = (type, onConfirm) => ({
  type: OPEN_CONFIRMATION_MODAL,
  payload: { type, onConfirm }
});

export const closeConfirmationModal = () => ({
  type: CLOSE_CONFIRMATION_MODAL,
  payload: { }
});

const initialState = {
  loading: true,
  openAccountPreferences: false,
  openConfirmationModal: false,
  confirmationModalType: null,
  confirmationModalOnConfirm: null
};

export default function(state=initialState, action) {

  switch (action.type) {
    case TOGGLE_LOADING:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading
      };

    case TOGGLE_ACCOUNT_PREFERENCES:
      const { openAccountPreferences } = action.payload;
      return {
        ...state,
        openAccountPreferences: openAccountPreferences
      };

    case OPEN_CONFIRMATION_MODAL:
      const { type, onConfirm } = action.payload;
      return {
        ...state,
        openConfirmationModal: true,
        confirmationModalType: type,
        confirmationModalOnConfirm: onConfirm,
      };

    case CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        openConfirmationModal: false,
        confirmationModalType: null,
        confirmationModalOnConfirm: null,
      };

    default:
      return state;
  }
}

